enum VehicleStatusEnum {
  Active = "online",
  Warning = "warning",
  InActive = "inactive",
  Offline = "offline"
}

export { VehicleStatusEnum };
